import { pipeline } from "@huggingface/transformers";

export interface ClassificationResult {
  label: string;
  score: number;
}

// Document analysis for fraud detection
export const analyzeDocument = async (imageUrl: string): Promise<ClassificationResult[]> => {
  const classifier = await pipeline(
    "image-classification",
    "onnx-community/mobilenetv4_conv_small.e2400_r224_in1k",
    { device: "webgpu" }
  );
  
  const result = await classifier(imageUrl);
  const formattedResult = Array.isArray(result) ? result : [result];
  return formattedResult.map(item => ({
    label: item.label,
    score: item.score
  }));
};

// Risk assessment based on text data
export const assessRisk = async (text: string): Promise<ClassificationResult[]> => {
  const classifier = await pipeline(
    "text-classification",
    "onnx-community/distilbert-base-uncased-finetuned-sst-2-english",
    { device: "webgpu" }
  );
  
  const result = await classifier(text);
  const formattedResult = Array.isArray(result) ? result : [result];
  return formattedResult.map(item => ({
    label: item.label,
    score: item.score
  }));
};

// Analyze user behavior patterns
export const analyzeBehavior = async (behaviorData: string) => {
  const extractor = await pipeline(
    "feature-extraction",
    "mixedbread-ai/mxbai-embed-xsmall-v1",
    { device: "webgpu" }
  );
  
  return await extractor(behaviorData, { pooling: "mean", normalize: true });
};